import { render, staticRenderFns } from "./UpdateInspiration.vue?vue&type=template&id=abf21a1a&scoped=true"
import script from "./UpdateInspiration.vue?vue&type=script&lang=js"
export * from "./UpdateInspiration.vue?vue&type=script&lang=js"
import style0 from "./UpdateInspiration.vue?vue&type=style&index=0&id=abf21a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf21a1a",
  null
  
)

export default component.exports